module.exports = __webpack_public_path__ + "img/icon-appstore-apple-dark.63762eed.svg";